import { translationBaseKey } from '../../../../../decorators/translation-base-key.decorator';
import { IsOptional, validateIf } from '@pristine-ts/class-validator';
import { ValidationGroupEnum } from '../../../../../enums/validation-group.enum';
import { clonePropertyMetadata } from '@pristine-ts/metadata';
import { CorporateIncomeTaxQuebecOptions } from '../quebec/corporate-income-tax-quebec.options';

@translationBaseKey('income-tax-corporation-quebec-in-corporate-income-tax-options')
export class CorporateIncomeTaxQuebecInCorporateIncomeTaxOptions implements Omit<CorporateIncomeTaxQuebecOptions,
  'calculationKeyname' |
  'fiscalYear' |
  'fiscalYearStart' |
  'fiscalYearEnd' |
  'companyType' |
  'totalTaxableCapital' |
  'businessIncome' |
  'adjustedInvestmentIncome' |
  'donations' |
  'capitalLossBalance' |
  'nonCapitalLossBalance' |
  'assignedBusinessLimit' |
  'connectedCorporations' |
  'taxableCanadianCorporateDividend' |
  'gainLossExcedent' |
  'tCCDividend'> {

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'currentPaidHours')
  currentPaidHours: number;
  //heuresRemunereesActuelles

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'previousPaidHours')
  @validateIf((object: CorporateIncomeTaxQuebecInCorporateIncomeTaxOptions, root, currentPath) => object.isManufacturingSectorActivity === false)
  previousPaidHours: number;
  //heuresRemunereesPrecedentes

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'propertyIncomeExceptCapitalGain')
  propertyIncomeExceptCapitalGain: number;
  //revenu_biens_autres_excepte_gain_perte

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'taxableIncomeOutsideCanada')
  taxableIncomeOutsideCanada: number = 0;
  //revenu_imposable_exterieur_Canada

  @clonePropertyMetadata<CorporateIncomeTaxQuebecOptions>(CorporateIncomeTaxQuebecOptions, 'isManufacturingSectorActivity')
  isManufacturingSectorActivity: boolean;
  //activite_secteur_manufacturier
}
